import loadable from '@nordvpn/teams.core/lib/tools/loadable';
// Lazy page entry, mounted by OrganizationsRouting behind the Orders redesign FF.
export var OrdersHistory = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/OrdersHistory');
});
export var OrderForm = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/OrderForm');
});
